import ls from '../../utils/localStorage.js';
import { getClan,getClanShow,getManualOne,getManualOneShow,getManualTwo,getManualTwoShow,getDonation,getDonationShow } from '../../api/api';

const state = {
   clan_list: '',
   clan_detail: '',
   manual_one: '',
   manual_one_detail: '',
   manual_two: '',
   manual_two_detail: '',
   donation_list: '',
   donation_detail:''
}

const mutations = {
   UPDATE_CLAN_LIST(state,payload) {
       state.clan_list = JSON.parse(payload);
   },
   UPDATE_CLAN_DETAIL(state,payload) {
       state.clan_detail = JSON.parse(payload);
   },
   UPDATE_MANUAL_ONE_LIST(state,payload) {
       state.manual_one = JSON.parse(payload);
   },
   UPDATE_MANUAL_ONE_DETAIL(state,payload) {
       state.manual_one_detail = JSON.parse(payload);
   },
   UPDATE_MANUAL_TWO_LIST(state,payload) {
       state.manual_two = JSON.parse(payload);
   },
   UPDATE_MANUAL_TWO_DETAIL(state,payload) {
       state.manual_two_detail = JSON.parse(payload);
   },
   UPDATE_DONATION_LIST(state,payload) {
       state.donation_list = JSON.parse(payload);
   },
   UPDATE_DONATION_SHOW(state,payload) {
       state.donation_detail = JSON.parse(payload);
   },
}

const getters = {

}

const actions = {
    // 获取列表
    requestClan(store,item) {
        getClan().then( data => {
            store.commit('UPDATE_CLAN_LIST',JSON.stringify(data.data));
        }).catch(error => {

        })
    },
    // 获取详情
    requestClanShow(store,item) {
        getClanShow(item.id).then( data => {
            store.commit('UPDATE_CLAN_DETAIL',JSON.stringify(data.data));
        }).catch(error => {

        })
    },
    // 获取列表族谱一
    requestManualOne(store,item) {
        getManualOne().then( data => {
            store.commit('UPDATE_MANUAL_ONE_LIST',JSON.stringify(data.data));
        }).catch(error => {

        })
    },
    // 获取详情一
    requestManualOneShow(store,item) {
        getManualOneShow(item.id).then( data => {
            store.commit('UPDATE_MANUAL_ONE_DETAIL',JSON.stringify(data.data));
        }).catch(error => {

        })
    },
    // 获取列表族谱二
    requestManualTwo(store,item) {
        getManualTwo(item.id).then( data => {
            store.commit('UPDATE_MANUAL_TWO_LIST',JSON.stringify(data.data));
        }).catch(error => {

        })
    },
    // 获取详情二
    requestManualTwoShow(store,item) {
        getManualTwoShow(item.id).then( data => {
            store.commit('UPDATE_MANUAL_TWO_DETAIL',JSON.stringify(data.data));
        }).catch(error => {

        })
    },

    // 捐赠列表
    requestDonation(store,item) {
        getDonation().then( data => {
            store.commit('UPDATE_DONATION_LIST',JSON.stringify(data.data));
        }).catch(error => {

        })
    },
    // 获取捐赠详情
    requestDonationShow(store,item) {
        getDonationShow(item.id).then( data => {
            store.commit('UPDATE_DONATION_SHOW',JSON.stringify(data.data));
        }).catch(error => {

        })
    },
}

export default {
    state,
    mutations,
    getters,
    actions
}
